<div *ngFor="let item of ItemsSource">
    <div class="tree-item" (dblclick)="OnClick(item)">
        <div [style.width.px]="20"
             (click)="OnClick(item)"
             class="tree-item-caret">
             <div *ngIf="HasChildren(item)">
                <pm-icon-down-arrow *ngIf="item._isExpanded"></pm-icon-down-arrow>
                <pm-icon-right-arrow *ngIf="!item._isExpanded"></pm-icon-right-arrow>
             </div>
        </div>
        
        <ng-container *ngTemplateOutlet="ItemTemplate; context: {$implicit: item}"></ng-container>
        
    </div>
    <div *ngIf="item._isExpanded" [style.padding-left.px]="10">        
        <pm-tree-item [ItemsSource]="GetChildren(item)"
                      [ItemTemplate]="ItemTemplate"
                      [DisplayMemberPath]="DisplayMemberPath"
                      [ChildPath]="ChildPath">
        </pm-tree-item>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/tree/tree-item.html